export enum DashboardTableType {
  TABLE = "TABLE",
  PIE = "PIE",
  COLUMN = "COLUMN",
  CUSTOM = "CUSTOM",
}
